module.exports = "/assets/landing-korw/instagram/instagram.png?FjF+KtA";